module.exports = ['$scope', '$sessionStorage', 'curriculumManager', 'ngMeta',
  function ($scope, $sessionStorage, CurriculumManager, ngMeta) {
    'use strict';
    ngMeta.setTitle('Het ordeningskader');

    $scope.$storage = $sessionStorage;
    if (!$scope.$storage.leerinhoudView) {
      $scope.$storage.leerinhoudView = 'tegel';
    }

    CurriculumManager.getCurriculum().then(function (curriculum) {
      $scope.curriculum = curriculum;
    });

    CurriculumManager.getFields().then(function (fields) {
      $scope.fields = fields;
      var i, field;
      for (i = 0; i < fields.length; i++) {
        field = fields[i];
        field.style = {
          'background-color': field.color
        };
      }
    });

    CurriculumManager.getPersoonsFields().then(function (fields) {
      $scope.persoonsFields = fields;
      var i, field;
      for (i = 0; i < fields.length; i++) {
        field = fields[i];
        field.style = {
          'background-color': field.color
        };
      }
    });

    CurriculumManager.getCultuurFields().then(function (fields) {
      $scope.cultuurFields = fields;
      var i, field;
      for (i = 0; i < fields.length; i++) {
        field = fields[i];
        field.style = {
          'background-color': field.color
        };
      }
    });
  }
];



// WEBPACK FOOTER //
// ./web/js/screen/leerinhoud/overview/leerinhoudOverviewController.js